export const STORAGE_KEY = 'example-vue-project'

let syncedData = {
  auth: {
    isLoggedIn: false,
    accessToken: null,
    refreshToken: null,
    user: null,
    register_state: false
  }
}

let phoneCheck = {
  phoneValidation: {
    requestValidationSend: false,
    phoneValid: false
  }
}

const notfications = {
  notify: {
    show: false,
    title: '',
    text: '',
    type: ''
  }
}

const notSyncedData = {
  appnav: {
    searchText: '',
    searchTimestamp: null
  }
}

const accountData = {
  phoneNumbers: [],
  vip_template: {
    'logo': '',
    'background_type': '',
    'page1_headline1': '',
    'page1_headline1_colour': '',
    'page1_headline1_size': '',
    'page1_headline2': '',
    'page1_headline2_colour': '',
    'page1_headline2_size': '',
    'page1_label_firstname': '',
    'page1_label_lastname': '',
    'page1_label_email': '',
    'page1_label_birthday': '',
    'page1_button_text': '',
    'page1_button_colour': '',
    'account_id': 0,
    'page3_headline1': '',
    'page3_headline1_colour': '',
    'page3_headline1_size': '',
    'page3_headline1_font': '',
    'page3_headline2': '',
    'page3_headline2_colour': '',
    'page3_headline2_size': '',
    'page3_headline2_font': '',
    'page3_button1_text': '',
    'page3_button1_colour': '',
    'page3_button1_font': '',
    'page3_button1_size': '',
    'page3_facebook_check': '',
    'page3_facebook_url': '',
    'page3_button_text': '',
    'page3_button_colour': '',
    'page3_button_font': '',
    'page3_button_size': '',
    'page1_headline1_font': '',
    'page1_headline2_font': '',
    'page1_button_font': '',
    'page1_button_size': '',
    'page1_headline1_decoration': '',
    'page1_headline1_alignment': '',
    'page1_headline2_decoration': '',
    'page1_headline2_alignment': '',
    'page3_headline1_decoration': '',
    'page3_headline1_alignment': '',
    'page3_headline2_decoration': '',
    'page3_headline2_alignment': '',
    'url': '',
    'page1_headline1_weight': '',
    'page1_headline2_weight': '',
    'page1_button_text_color': '',
    'page3_headline1_weight': '',
    'page3_headline2_weight': '',
    'page3_button_text_color': '',
    'labels_color': '',
    'errors_colors': '',
    'tracking_codes': '',
    'labels_font': '',
    'labels_font_size': '',
    'errors_font': '',
    'errors_font_size': '',
    'show_twitter': '',
    'show_instagram': '',
    'show_webpage': '',
    'vip_label': '',
    'vip_icon': '',
    'google_maps_link': '',
    'business_phone': '',
    'show_google_maps_link': '',
    'show_business_phone': '',
    'contact_buttons_color': '',
    'validate_button_color': '',
    'validate_button_font': '',
    'show_birthday_field': ''
  },
  vipKeywords: [],
  slug: '',
  credit: 0,
  monthlyUsed: 0,
  vipIcons: []
}

let promotions = {
  promotions: [],
  availablePromos: []
}

let campaigns = {
  campaigns: []
}

let permanentCampaigns = {
  permanentCampaigns: []
}

let staff = {
  staff: []
}
let promotion = {
  promotion: []
}
let dashboard = {
  todayLeads: '',
  weekLeads: '',
  ncv_value: '',
  overAll: '',
  outgoing: '',
  incoming: ''
}
let viralCampaign = {
  viralCampaign: []
}
let viralPermanent = {
  viralPermanent: []
}

let cart = {
  cart: []
}

let showCart = {
  showCart: false
}

let accountNotifications = {
  accountNotifications: []
}

// Sync with local storage.
if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))
}

// Merge data and export it.
export const state = Object.assign(syncedData, notSyncedData, notfications, phoneCheck, accountData, promotions, campaigns, permanentCampaigns, staff, promotion, dashboard, viralCampaign, viralPermanent, cart, showCart, accountNotifications)



// WEBPACK FOOTER //
// ./src/store/state.js